import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeFilterState } from '../../shared/change-flags';

/**
 * "Changes" scope control (All · ▲ Up · ▼ Down · ◆ Future) for the broker
 * rate-sheet rails. Multi-select OR semantics: none selected = All.
 */
@Component({
  selector: 'app-rate-sheet-changes',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="knob chg-knob">
      <span class="klabel">Changes</span>
      <div class="chg-switch" role="group" aria-label="Show products by rate change">
        <button type="button" class="chg-opt" [class.on]="!anyOn()" (click)="all()"
                title="All products">All</button>
        <button type="button" class="chg-opt chg-up" [class.on]="state.changeUp()"
                (click)="toggle('up')" [attr.aria-pressed]="state.changeUp()"
                title="Scheduled increase">▲</button>
        <button type="button" class="chg-opt chg-dn" [class.on]="state.changeDown()"
                (click)="toggle('down')" [attr.aria-pressed]="state.changeDown()"
                title="Scheduled decrease">▼</button>
        <button type="button" class="chg-opt" [class.on]="state.changeFuture()"
                (click)="toggle('future')" [attr.aria-pressed]="state.changeFuture()"
                title="Any scheduled future rate">◆</button>
      </div>
    </div>
  `,
  styles: [`
    .knob { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin: 8px 0; }
    .klabel { font-size: 12px; color: var(--text2); font-weight: 600; }
    .chg-switch {
      display: inline-flex; height: 26px; padding: 2px;
      border: 1px solid var(--border-light); border-radius: 14px;
      background: var(--bg); overflow: hidden; flex-shrink: 0;
    }
    .chg-opt {
      border: 0; background: transparent; padding: 0 9px; height: 100%;
      font: inherit; font-size: 11px; font-weight: 600; color: var(--muted);
      cursor: pointer; border-radius: 12px; transition: background .12s, color .12s, box-shadow .12s;
    }
    .chg-opt.chg-up { color: var(--pos); }
    .chg-opt.chg-dn { color: var(--neg); }
    .chg-opt:hover { color: var(--text); }
    .chg-opt.on { background: var(--panel); color: var(--navy); font-weight: 700; box-shadow: var(--shadow-xs, 0 1px 2px rgba(13,42,69,.08)); }
    .chg-opt.chg-up.on { color: var(--pos); }
    .chg-opt.chg-dn.on { color: var(--neg); }
  `],
})
export class RateSheetChangesComponent {
  @Input({ required: true }) state!: ChangeFilterState;

  anyOn(): boolean {
    return this.state.changeUp() || this.state.changeDown() || this.state.changeFuture();
  }
  all(): void {
    this.state.changeUp.set(false);
    this.state.changeDown.set(false);
    this.state.changeFuture.set(false);
  }
  toggle(k: 'up' | 'down' | 'future'): void {
    const s = k === 'up' ? this.state.changeUp
            : k === 'down' ? this.state.changeDown
            : this.state.changeFuture;
    s.set(!s());
  }
}
